import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedLayout from '../components/layout/ProtectedLayout';
import PrivateRoute from './PrivateRoute';

import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Companies from '../pages/Companies';
import CompanyDetails from '../pages/CompanyDetails';
import RequestForms from '../pages/RequestForms';
import EmployeeLimits from '../pages/EmployeeLimits';
import EmployeeIdSettings from '../pages/EmployeeIdSettings';
import AdminAccess from '../pages/AdminAccess';
import Chatbot from '../pages/Chatbot';
import Settings from '../pages/Settings';
import NotFound from '../pages/NotFound';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <ProtectedLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="companies" element={<Companies />} />
        <Route path="companies/:id" element={<CompanyDetails />} />
        <Route path="request-forms" element={<RequestForms />} />
        <Route path="employee-limits" element={<EmployeeLimits />} />
        <Route path="employee-id-settings" element={<EmployeeIdSettings />} />
        <Route path="admin-access" element={<AdminAccess />} />
        <Route path="chatbot" element={<Chatbot />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
